/* istanbul ignore file */
import { useFiltersVisibilityHelper, FiltersLayoutProps } from 'framework/list';
import { UiThemeOverrider } from 'framework/uiTheme';
import CandidateDropDownFilterButtonLayout from './CandidateDropdownFilterButtonLayout';

const CandidateListFiltersLayout = ({ children }: FiltersLayoutProps) => {
  const { getFilteredChildren } = useFiltersVisibilityHelper({ children });

  return (
    <UiThemeOverrider
      overriddenLayouts={{
        DropdownLayout: CandidateDropDownFilterButtonLayout,
      }}
    >
      {getFilteredChildren()}
    </UiThemeOverrider>
  );
};

export default CandidateListFiltersLayout;
